<script setup lang="ts">
import type { ApiLogisticsTaskGetById, ApiPublicTransportationCompanyDriveGetLogisticsTaskByCuid } from '~/types'

const { logisticsTask, isPublicPage = false } = defineProps<{
  logisticsTask: ApiLogisticsTaskGetById | ApiPublicTransportationCompanyDriveGetLogisticsTaskByCuid
  isPublicPage?: boolean
}>()

const isEditingDisabled = computed(() => logisticsTask.status !== 'collected')

const hasPositionTerminated = computed(() => {
  return logisticsTask.offer?.obligationActuallyEndedAt
    || logisticsTask.positionsToShip.some((position) => {
      return position.terminatedDate
    })
})

const publicCollectionChecklistPayload = ref<string | null>(null)

const { openDriverCollectionChecklistPopup } = useGlobalOpeners()

function openCollectionChecklist() {
  if (isPublicPage) {
    publicCollectionChecklistPayload.value = logisticsTask.cuid
    return
  }
  openDriverCollectionChecklistPopup.open({ id: logisticsTask.id })
}
</script>

<template>
  <TheDataCard>
    <template #header>
      <div class="CardHeader">
        <h2>{{ $t('logisticsTask.collectionChecklist.title') }}</h2>
        <n-button v-if="hasPositionTerminated && !isEditingDisabled" @click="openCollectionChecklist">
          <template #icon>
            <Icon name="material-symbols:edit-outline-rounded" />
          </template>
          {{ $t('button.update') }}
        </n-button>
      </div>
    </template>

    <template v-if="hasPositionTerminated">
      <div v-if="logisticsTask.status === 'delivered'" class="flex justify-between">
        <span>{{ $t('common.empty') }}</span>
        <n-button @click="openCollectionChecklist">
          {{ $t('logisticsTask.checklist.fillOut') }}
        </n-button>
      </div>
      <DriverCollectionChecklistForm v-else :logistics-task="logisticsTask" :view-only="true" />
    </template>
    <div v-else class="text-center mt-5">
      {{ $t('logisticsTask.collectionChecklist.notCancelled') }}
    </div>
  </TheDataCard>

  <DriverPublicTransportationCompanyCollectionChecklistContainer v-if="publicCollectionChecklistPayload" :logistics-task-cuid="publicCollectionChecklistPayload" @close="publicCollectionChecklistPayload = null" />
</template>

<style scoped>
.CardHeader {
  @apply  w-full flex justify-between mb-5
}
.CardHeader h2 {
  @apply text-lg font-semibold
}
</style>
